import { Pipe, PipeTransform, inject } from '@angular/core';

import { SAVING_ARENA_API_CONFIG } from './api.config';

@Pipe({
  name: 'assetUrl',
  standalone: true,
})
export class AssetUrlPipe implements PipeTransform {
  private readonly config = inject(SAVING_ARENA_API_CONFIG);

  transform(path: string | null | undefined): string {
    if (!path) {
      return '';
    }

    if (/^https?:\/\//i.test(path)) {
      return path;
    }

    const assetBaseUrl = this.config.assetBaseUrl.replace(/\/$/, '');
    const assetPath = path.startsWith('/') ? path : `/${path}`;

    return `${assetBaseUrl}${assetPath}`;
  }
}
